export const COMMENT_HASH = "#comment";
export const COMMENT_HASH_NOTI = "#comment_noti";
export const REPLY_HASH = "#reply";
export const REPLY_HASH_NOTI = "#reply_noti";
